<template>
  <section :class="classNames.section">
    <div :class="classNames.content">
      <ContentTitle v-if="title" :align-left="alignLeft" :flat="flat || flatTitle">{{ title }}</ContentTitle>
      <slot />
    </div>
  </section>
</template>

<script>
import ContentTitle from './ContentTitle.vue'

export default {
  name: 'ContentSection',
  components: { ContentTitle },
  props: {
    title: { type: String, default: null },
    altBackground: { type: Boolean, default: false },
    alignLeft: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    flatTitle: { type: Boolean, deault: false },
    contentClass: { type: [String, Array, Object], default: null }
  },
  computed: {
    classNames() {
      return {
        section: ['section', { '-alt': this.altBackground, '-flat': this.flat }],
        content: ['section__content', this.contentClass]
      }
    }
  }
}
</script>
